// Mixin for handling delete confirmation dialogs
export default {
  data() {
    return {
      deleteDialog: false,
      deleteLoading: false,
      itemToDelete: null
    }
  },
  
  methods: {
    /**
     * Shows the delete confirmation dialog
     * @param {Object} item - The item to be deleted
     */
    deleteShowConfirmDialog(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    
    /**
     * Cancels the delete operation
     */
    cancelDelete() {
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    
    /**
     * Performs the delete operation - should be overridden in components
     * @param {Object} item - The item to delete (optional, uses this.itemToDelete if not provided)
     */
    async deleteItem(item = null) {
      const targetItem = item || this.itemToDelete;
      
      if (!targetItem) {
        console.warn('No item selected for deletion');
        return;
      }
      
      // This method should be overridden in the component
      // Example implementation:
      /*
      this.deleteLoading = true;
      try {
        await api.yourEntity.delete(targetItem.code || targetItem.id);
        this.showSuccessMessage('Item deleted successfully');
        this.deleteDialog = false;
        this.refreshData(); // or this.fetchGridData()
      } catch (error) {
        this.showErrorMessage(error.response?.data?.message || 'Failed to delete item');
      } finally {
        this.deleteLoading = false;
      }
      */
      
      throw new Error('deleteItem method must be implemented in the component');
    },
    
    /**
     * Helper method to show success messages - can be overridden
     * @param {String} message - Success message to display
     */
    showSuccessMessage(message) {        
      if (this.snackbar !== undefined) {
        this.snackbarColor = 'green';
        this.snackbarMessage = message;
        this.snackbar = true;
      } else {
        // Fallback for components without snackbar
        this.$toast?.success?.(message) || console.log('Success:', message);
      }
    },
    
    /**
     * Helper method to show error messages - can be overridden
     * @param {String} message - Error message to display
     */
    showErrorMessage(message) {
      if (this.snackbar !== undefined) {
        this.snackbarColor = 'red';
        this.snackbarMessage = message;
        this.snackbar = true;
      } else {
        // Fallback for components without snackbar
        this.$toast?.error?.(message) || console.error('Error:', message);
      }
    }
  }
};